import { useCurrencyHelpers } from '../../lib/hooks/use-currency-helpers.ts';

type Props = {
    children: string | number | undefined | null;
    currency?: string;
    decimals?: number;
    showEmptyIfZero?: boolean;
    emptyText?: string;
    showPlusSignIfPositive?: boolean;
};

export function CurrencyOrEmpty({
    decimals = 0,
    currency,
    children,
    emptyText = '-',
    showEmptyIfZero = false,
    showPlusSignIfPositive = false,
}: Props) {
    const { formatCurrency } = useCurrencyHelpers();

    const formattedValue = formatCurrency(children, {
        decimals,
        currency,
        showEmptyIfZero,
        emptyText,
        showPlusSignIfPositive,
    });

    return <>{formattedValue}</>;
}
